import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import AdditionalInformationForm from "../../AdditionalInformationForm";
import { useEffect } from "react";

const Step3 = ({
  formik,
  data,
  identity,
  handleSelectIdentity,
  identityImage,
  handleIdentityImage,
  drivingLicense,
  handleDrivingLisence,
  familyCard,
  handleFamilyCard,
  businessId,
  handleBusinessId,
  hotel,
  flight,
  handleHotel,
  handleFlight,
  t,
}) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="px-4 py-6">
      {/* Required Documents */}
      {data?.type === "self_drive" && (
        <div className="mt-8 booking-modal__person-info">
          <h4>{t("required_documents") || "Required Documents"}</h4>
          <div className="info-form__1col">
            <span>
              <label>
                {t("identity_type")} <b>*</b>
              </label>
              <select value={identity} defaultValue="" onChange={handleSelectIdentity}>
                <option value="" disabled>
                  {t("select_identity")}
                </option>
                <option value="ktp">KTP</option>
                <option value="passport">PASSPORT</option>
                <option value="kitas">KITAS</option>
              </select>
              {formik.touched.identity && formik.errors.identity ? (
                <p className="error-modal">{formik.errors.identity}</p>
              ) : null}
            </span>
          </div>

          <div className="info-form__2col">
            <span>
              <label>
                {t("identity_image")} <b>*</b>
              </label>
              <input type="file" accept="image/jpeg, image/png, image/jpg" onChange={handleIdentityImage} />
              {identityImage && (
                <p className="mt-1 text-sm !text-green-600">✓ File uploaded: {identityImage[0]?.name}</p>
              )}
              {formik.touched.identity_image && formik.errors.identity_image ? (
                <p className="error-modal">{formik.errors.identity_image}</p>
              ) : null}
            </span>

            <span>
              <label>
                {t("sim_or")} <b>*</b>
              </label>
              <input type="file" accept="image/jpeg, image/png, image/jpg" onChange={handleDrivingLisence} />
              {drivingLicense && (
                <p className="mt-1 text-sm !text-green-600">✓ File uploaded: {drivingLicense[0]?.name}</p>
              )}
              {formik.touched.driving_license && formik.errors.driving_license ? (
                <p className="error-modal">{formik.errors.driving_license}</p>
              ) : null}
            </span>

            <span>
              <label>{t("family_card") || "Kartu Keluarga (KK)"}</label>
              <input type="file" accept="image/jpeg, image/png, image/jpg" onChange={handleFamilyCard} />
              {familyCard && <p className="mt-1 text-sm !text-green-600">✓ File uploaded: {familyCard[0]?.name}</p>}
              {formik.touched.family_card && formik.errors.family_card ? (
                <p className="error-modal">{formik.errors.family_card}</p>
              ) : null}
            </span>
            <span>
              <label>{t("business_id") || "ID Usaha / Business ID"}</label>
              <input type="file" accept="image/jpeg, image/png, image/jpg" onChange={handleBusinessId} />
              {businessId && <p className="mt-1 text-sm !text-green-600">✓ File uploaded: {businessId[0]?.name}</p>}
              {formik.touched.business_id && formik.errors.business_id ? (
                <p className="error-modal">{formik.errors.business_id}</p>
              ) : null}
            </span>
          </div>
        </div>
      )}
      <div className="booking-modal__person-info">
        <h4>{t("personal_info")}</h4>

        <div className="info-form__2col">
          <span>
            <label>
              {t("booker_name")}
              <b>*</b>
            </label>
            <input type="text" placeholder={t("enter_booker_name")} {...formik.getFieldProps("name")}></input>
            {formik.touched.name && formik.errors.name ? <p className="error-modal">{formik.errors.name}</p> : null}
          </span>

          <span>
            <label>
              {t("whatsapp_number")} <b>*</b>
            </label>
            <PhoneInput
              specialLabel={""}
              enableSearch
              country={"id"}
              onChange={(v) => {
                formik.setFieldValue("phone", v);
              }}
              name="phone"
              value={formik.values.phone}
              onBlur={formik.handleBlur}
              inputStyle={{
                width: "100%",
                backgroundColor: "#dbdbdb",
                borderRadius: 0,
                border: "none",
                fontSize: "1.5rem",
                padding: "14px 8px 14px 58px",
              }}
            />
            {formik.touched.phone && formik.errors.phone ? <p className="error-modal">{formik.errors.phone}</p> : null}
          </span>

          <span>
            <label>
              {t("email")} <b>*</b>
            </label>
            <input
              type="email"
              placeholder={t("enter_email")}
              {...formik.getFieldProps("email")}
              value={formik.values.email}
              onChange={(e) => formik.setFieldValue("email", e.target.value.toLowerCase())}
            />
            {formik.touched.email && formik.errors.email ? <p className="error-modal">{formik.errors.email}</p> : null}
          </span>
          <span>
            <label>
              {t("social_media")} <b>*</b>
            </label>
            <input type="text" placeholder={t("enter_social_media")} {...formik.getFieldProps("social_media")}></input>
            {formik.touched.social_media && formik.errors.social_media ? (
              <p className="error-modal">{formik.errors.social_media}</p>
            ) : null}
          </span>
          <span>
            <label>
              {t("address")} <b>*</b>
            </label>
            <input type="text" placeholder={t("enter_address")} {...formik.getFieldProps("address")}></input>
            {formik.touched.address && formik.errors.address ? (
              <p className="error-modal">{formik.errors.address}</p>
            ) : null}
          </span>

          {data?.type === "self_drive" ? (
            <>
              <span>
                <label>
                  {t("emergency_contact_1")} <b>*</b>
                </label>
                <PhoneInput
                  specialLabel={""}
                  enableSearch
                  country={"id"}
                  onChange={(v) => formik.setFieldValue("additional_informations.emergencyContact1", v)}
                  name="additional_informations.emergencyContact1"
                  value={formik.values?.additional_informations?.emergencyContact1 || ""}
                  onBlur={formik.handleBlur}
                  inputStyle={{
                    width: "100%",
                    backgroundColor: "#dbdbdb",
                    borderRadius: 0,
                    border: "none",
                    fontSize: "1.5rem",
                    padding: "14px 8px 14px 58px",
                  }}
                />
                {formik.touched?.additional_informations?.emergencyContact1 &&
                formik.errors?.additional_informations?.emergencyContact1 ? (
                  <p className="error-modal">{formik.errors.additional_informations.emergencyContact1}</p>
                ) : null}
              </span>

              <span>
                <label>
                  {t("emergency_contact_2")} <b>*</b>
                </label>
                <PhoneInput
                  specialLabel={""}
                  enableSearch
                  country={"id"}
                  onChange={(v) => formik.setFieldValue("additional_informations.emergencyContact2", v)}
                  name="additional_informations.emergencyContact2"
                  value={formik.values?.additional_informations?.emergencyContact2 || ""}
                  onBlur={formik.handleBlur}
                  inputStyle={{
                    width: "100%",
                    backgroundColor: "#dbdbdb",
                    borderRadius: 0,
                    border: "none",
                    fontSize: "1.5rem",
                    padding: "14px 8px 14px 58px",
                  }}
                />
                {formik.touched?.additional_informations?.emergencyContact2 &&
                formik.errors?.additional_informations?.emergencyContact2 ? (
                  <p className="error-modal">{formik.errors.additional_informations.emergencyContact2}</p>
                ) : null}
              </span>
            </>
          ) : null}

          <span />

          <AdditionalInformationForm
            formik={formik}
            data={data}
            flight={flight}
            hotel={hotel}
            handleFlight={handleFlight}
            handleHotel={handleHotel}
          />
        </div>

        <div className="info-form__1col">
          <span>
            <label>{t("notes")}</label>
            <textarea placeholder={t("enter_notes")} rows={3} {...formik.getFieldProps("notes")} />
          </span>
        </div>
      </div>

      <span className="info-form__checkbox">
        <i className="fa-solid fa-circle-exclamation"></i> <p>{t("we_will_ask")}</p>
      </span>
    </div>
  );
};

export default Step3;
